import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../../core/auth-service';

@Component({
  selector: 'app-device-details',
  templateUrl: './device-details.component.html',
  styleUrl: './device-details.component.scss'
})
export class DeviceDetailsComponent implements OnInit {
  browser: string = '';
  version: string = '';
  os: string = '';

  constructor(private msal: MsalService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    const browserInfo = this.getBrowserInfo();
    this.browser = browserInfo.browser;
    this.version = browserInfo.version;
    this.os = this.getOS();
  }

private getBrowserInfo(): { browser: string; version: string } {
  const ua = navigator.userAgent;

  if (/edg/i.test(ua)) {
    return { browser: 'Edge', version: ua.match(/edg\/([\d]+)/i)?.[1] ?? '' };
  } else if (/chrome|crios|crmo/i.test(ua)) {
    return { browser: 'Chrome', version: ua.match(/chrome\/([\d]+)/i)?.[1] ?? '' };
  } else if (/firefox|fxios/i.test(ua)) {
    return { browser: 'Firefox', version: ua.match(/firefox\/([\d]+)/i)?.[1] ?? '' };
  } else if (/safari/i.test(ua)) {
    return { browser: 'Safari', version: ua.match(/version\/([\d]+)/i)?.[1] ?? '' };
  }

  return { browser: 'Unknown', version: '' };
}

  private getOS(): string {
    const ua = navigator.userAgent;
    if (/windows nt/i.test(ua)) return 'Windows';
    if (/android/i.test(ua)) return 'Android';
    if (/iphone|ipad|ipod/i.test(ua)) return 'iOS';
    if (/mac os/i.test(ua)) return 'MacOS';
    if (/linux/i.test(ua)) return 'Linux';
    return 'Unknown';
  }
}
